import { faRecycle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";

export default function AboutUs() {
  return (
    <div className="container flex justify-center items-center mt-20">
      <div className="w-2/4 text-center">
        <FontAwesomeIcon icon={faRecycle} className="text-5xl text-lime-600" />

        <h5 className="font-bold text-4xl mt-4">Welcome to Green Care Blitz</h5>
        <p className="text-base mt-1">MORE ABOUT US</p>

        <p className="text-slate-400 mt-5">
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Aut harum minima quaerat esse mollitia quas delectus sapiente laboriosam pariatur quae. Ipsa qui fugiat, consequatur minima sit eligendi dolores ducimus autem quia deserunt iure nobis recusandae perferendis molestias repellat facilis tempore.
        </p>

        <img src={require("../../images/signature.png")} alt="Siganture" className="mx-auto w-60" />
      </div>
    </div>
  );
}
